import script from "./ModalCerrarSesion.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCerrarSesion.vue?vue&type=script&setup=true&lang=js"

import "./ModalCerrarSesion.vue?vue&type=style&index=0&id=49398c6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49398c6b"]])

export default __exports__